/**
 * A part of the rave app that can only be LOOKED AT — for the setup wizard's
 * framed preview, which is read-only (round 7, the user's point 51: "remove
 * all the options to touch in the preview").
 *
 * Framed, the children are drawn as they are and wrapped `inert`: no click,
 * no focus, no typing, so meeting people, rides, photos and the paywall show
 * what a raver sees without anything in them being pressable. The page still
 * scrolls. Not framed, the children are returned untouched — the real app
 * never gets the wrapper. (Writes are refused in `lib/api.ts` too; this is
 * what the person sees.)
 */
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { isFramed } from '@/lib/framed';
import './ReadOnly.css';

export function ReadOnly({ children }: { children: ReactNode }) {
  const [framed] = useState(isFramed);
  const ref = useRef<HTMLDivElement>(null);
  // React 18 has no `inert` prop; the attribute is set on the node.
  useEffect(() => { if (framed) ref.current?.setAttribute('inert', ''); }, [framed]);
  if (!framed) return <>{children}</>;
  return <div ref={ref} className="read-only" data-read-only="">{children}</div>;
}
